import http from './../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre

export default {
  getList(params) {
    return http.requestPost(apiPre + service.pay + '/operator_payment/listPage', params)
  },
  //编辑
  op_edit(params) {
    return http.requestGet(apiPre + service.pay + '/operator_payment/getById/' + params, {})
  },
  delete(params) {
    return http.requestPostKeyValue(apiPre + service.pay + '/rbac/menu/delete', params)
  },
  insert(params) {
    return http.requestPost(apiPre + service.pay + '/rbac/menu/insert', params)
  },
  update(params) {
    return http.requestPost(apiPre + service.pay + '/rbac/menu/update', params)
  },
  listStationPayment(params) {
    return http.requestPost(apiPre + service.pay + '/operator_payment/listStationPayment', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/systemManagement/api/operatorPayment.js